"use strict";

require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return escapeCommas;
  }
});
function escapeCommas(className) {
  return className.replace(/\\,/g, "\\2c ");
}